import { t } from 'localization'

const TP = 'search.enums.search'

export enum SortOption {
  Popular = 'popular',
  PriceLowHigh = 'price_asc',
  PriceHighLow = 'price_desc',
  Newest = 'newest',
  Trending = 'trending',
  Collection = 'collection',
}

export const SortOptionLabel = () => ({
  Popular: t(`${TP}.popular`, 'Popular'),
  PriceLowHigh: t(`${TP}.priceLow`, 'Price (Low to High)'),
  PriceHighLow: t(`${TP}.priceHigh`, 'Price (High to Low)'),
  Newest: t(`${TP}.newest`, 'Newest'),
})

export const getSortOptionByAlgoliaIndex = (algoliaIndex: string) => {
  switch (algoliaIndex) {
    case 'product_variants_v2_flight_club':
      return SortOption.Popular
    case 'product_variants_v2_by_price_asc_flight_club':
      return SortOption.PriceLowHigh
    case 'product_variants_v2_by_price_desc_flight_club':
      return SortOption.PriceHighLow
    case 'product_variants_v2_by_newest_desc_flight_club':
      return SortOption.Newest
    case 'product_variants_v2_trending_purchase_flight_club':
      return SortOption.Trending
    default:
      return SortOption.Popular
  }
}

// in the order they appear on the filters
export enum SearchFiltersRefinement {
  Brand = 'brand_name',
  Category = 'single_gender',
  Color = 'color',
  Condition = 'shoe_condition',
  LowestPrice = 'lowest_price_cents',
  // Style doesnt have a correlating face atm
  MenSizes = 'size_us_men',
  PresentationSizes = 'presentation_size',
  ProductType = 'product_type',
  Silhouette = 'silhouette',
  WomenSizes = 'size_us_women',
  Year = 'release_year',
  YouthSizes = 'size_us_youth',
}

export const SearchFiltersHumanizedRefinement = () => ({
  brand_name: t(`${TP}.brand`, 'Brand'),
  color: t(`${TP}.color`, 'Color'),
  lowest_price_cents: t(`${TP}.price`, 'Price'),
  presentation_size: t(`${TP}.size`, 'Size'),
  product_type: t(`${TP}.productType`, 'Category'),
  release_year: t(`${TP}.year`, 'Year'),
  shoe_condition: t(`${TP}.condition`, 'Condition'),
  silhouette: t(`${TP}.model`, 'Model'),
  single_gender: t(`${TP}.category`, 'Category'),
  // Style doesnt have a correlating face atm
  size_us_men: t(`${TP}.menSize`, "US Men's Sizes"),
  size_us_women: t(`${TP}.womenSizes`, "US Women's Sizes"),
  size_us_youth: t(`${TP}.youthSizes`, 'US Youth Sizes'),
})

export enum SearchCurrency {
  USD = 'USD',
}

// not being used?
export const TranslationNeeded = () => ({
  single_gender: t(`${TP}.single_gender`, 'Category'),
  shoe_condition: t(`${TP}.shoe_condition`, 'Condition'),
  size_us_men: t(`${TP}.size_us_men`, "Men's Sizes"),
  size_us_women: t(`${TP}.size_us_women`, "Women's Sizes"),
  size_us_youth: t(`${TP}.size_us_youth`, 'Youth Sizes'),
  release_year: t(`${TP}.release_year`, 'Year'),
  color: t(`${TP}.color`, 'Color'),
  silhouette: t(`${TP}.silhouette`, 'Model'),
  brand_name: t(`${TP}.brand_name`, 'Brand'),
  lowest_price_cents: t(`${TP}.lowest_price_cents`, 'Price'),
  presentation_size: t(`${TP}.presentation_size`, 'Size'),
  Popular: t(`${TP}.Popular`, 'Popular'),
  PriceLowHigh: t(`${TP}.Price low`, 'Price low'),
  PriceHighLow: t(`${TP}.Price high`, 'Price high'),
  Newest: t(`${TP}.Newest`, 'Newest'),
  Trending: t(`${TP}.Trending`, 'Trending'),
})

export const conditionFilterOption = () => ({
  newNoDefects: t(`${TP}.newNoDefects`, 'New No Defects'),
  newWithDefects: t(`${TP}.newWithDefects`, 'New With Defects'),
  used: t(`${TP}.used`, 'Used'),
})

export const colorFilterOption = () => ({
  black: t(`${TP}.black`, 'Black'),
  blue: t(`${TP}.blue`, 'Blue'),
  brown: t(`${TP}.brown`, 'Brown'),
  copper: t(`${TP}.copper`, 'Copper'),
  cream: t(`${TP}.cream`, 'Cream'),
  gold: t(`${TP}.gold`, 'Gold'),
  gray: t(`${TP}.gray`, 'Gray'),
  green: t(`${TP}.green`, 'Green'),
  grey: t(`${TP}.grey`, 'Grey'),
  multiColor: t(`${TP}.multi-color`, 'Multi-Color'),
  orange: t(`${TP}.orange`, 'Orange'),
  pink: t(`${TP}.pink`, 'Pink'),
  purple: t(`${TP}.purple`, 'Purple'),
  red: t(`${TP}.red`, 'Red'),
  silver: t(`${TP}.silver`, 'Silver'),
  tan: t(`${TP}.tan`, 'Tan'),
  teal: t(`${TP}.teal`, 'Teal'),
  white: t(`${TP}.white`, 'White'),
  yellow: t(`${TP}.yellow`, 'Yellow'),
})
